module.exports = __webpack_public_path__ + "img/ring_r_s_0_0.8853f4ef.png";